import { name } from "./dataModels.reducers";

export const selectSlice = (state) => state[name];

export const selectCollections = (state) => selectSlice(state).collections;

export const selectTableData = (state) => selectSlice(state).tableData;

export const selectCollection = (state) => selectSlice(state).collection;

export const selectSelectedProperty = (state) =>
  selectSlice(state).selectedProperty;

export const selectDataModels = (state) => selectSlice(state).dataModels;

export const selectSelectedDataModelId = (state) =>
  selectSlice(state).selectedDataModelId;

export const selectFilters = (state) => selectSlice(state).filters;
export const selectBackgroundTasks = (state) =>
  selectSlice(state).backgroundTasks;

export const selectTotalBackgroundTasks = (state) =>
  selectSlice(state).totalBackgroundTasks;

export const selectTotalCollections = (state) =>
  selectSlice(state).totalCollections;

export const selectSelectedDataModel = (state) =>
  selectSlice(state).selectedDataModel;

export const selectSelectedDataTable = (state) =>
  selectSlice(state).selectedDataTable;

export const selectTotalDataModels = (state) =>
  selectSlice(state).totalDataModels;

export const selectSelectedBackgroundTask = (state) =>
  selectSlice(state).selectedBackgroundTask;

export const selectDataModelsFilters = (state) =>
  selectSlice(state).dataModelsFilters;

export const selectCollectionsFilters = (state) =>
  selectSlice(state).collectionsFilters;

export const selectTableDataFilters = (state) =>
  selectSlice(state).tableDataFilters;

export const selectFormattedFilters = (state) =>
  selectSlice(state).formattedFilters;

export const selectBackgroundTaskFilters = (state) =>
  selectSlice(state).backgroundTaskFilters;

export const selectEndpointFilters = (state) =>
  selectSlice(state).endpointFilters;

export const selectServiceFilters = (state) =>
  selectSlice(state).serviceFilters;

export const selectSelectedRecords = (state) =>
  selectSlice(state).selectedRecords;

export const selectSelectedCollectionId = (state) =>
  selectSlice(state).selectedCollectionId;

export const selectTotalEndpoints = (state) =>
  selectSlice(state).totalEndpoints;

export const selectTotalServices = (state) => selectSlice(state).totalServices;

export const selectEndpoints = (state) => selectSlice(state).endpoints;

export const selectServices = (state) => selectSlice(state).services;

export const selectSelectedEndpoint = (state) =>
  selectSlice(state).selectedEndpoint;

export const selectService = (state) => selectSlice(state).service;

export const selectSelectedServiceId = (state) =>
  selectSlice(state).selectedServiceId;

export const selectSelectedNode = (state) => selectSlice(state).selectedNode;

export const selectShouldShowLoadingPage = (state) =>
  selectSlice(state).shouldShowLoadingPage;

export const selectSelectedNodeDetails = (state) =>
  selectSlice(state).nodeDetails;

export const selectSwaggerData = (state) => selectSlice(state).swaggerData;

export const selectDataModelRegions = (state) =>
  selectSlice(state).dataModelRegions;

export const selectDeployStatus = (state) => selectSlice(state).deployStatus;

export const selectPipelineStatus = (state) =>
  selectSlice(state).pipelineStatus;

export const selectReferenceCollectionsData = (state) =>
  selectSlice(state).referenceCollectionsData;

export const selectRecentDeployedEndpointInfo = (state) =>
  selectSlice(state).recentDeployedEndpointInfo;

export const selectSelectedSecrets = (state) => selectSlice(state).secrets;

export const selectSelectedSecretKey = (state) =>
  selectSlice(state).selectedSecretKey;

export const selectDataModelDeploymentsTrack = (state) =>
  selectSlice(state).dataModelDeploymentsTrack;

export const selectAutoMapper = (state) => selectSlice(state).autoMapper;

export const selectNewService = (state) => selectSlice(state).newService;

export const selectSelectedDataModelResources = (state) =>
  selectSlice(state).dataModelResources;

export const selectAreResourcesPending = (state) =>
  selectSlice(state).areResourcesPending;

export const selectDataModelWithPendingResources = (state) =>
  selectSlice(state).dataModelWithPendingResources;
